// extracted by mini-css-extract-plugin
module.exports = {"horizontal-scroller":"NumberScroller_horizontal-scroller__2C8HV"};